import React from 'react';
import { Link } from 'react-router-dom';

function FormsIndex() {
  // simple inline helpers to keep the look tidy without new CSS
  const sectionWrap = { marginBottom: 28 };
  const sectionHead = { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 };
  const divider = { borderTop: '1px solid rgba(0,0,0,0.08)', margin: '6px 0 14px' };
  const list = { listStyle: 'none', padding: 0, margin: 0 };
  const row = {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
    padding: '14px 0',
    borderBottom: '1px solid rgba(0,0,0,0.06)',
  };
  const title = { margin: 0, fontSize: '1.05rem', lineHeight: 1.35 };
  const desc = { margin: '4px 0 0', color: '#475569' };

  // Consistent button sizing for all actions
  const btnStyle = { minWidth: 170, whiteSpace: 'nowrap' };

  return (
    <>
      <section className="service-one-section">
        <div className="container">

          {/* Intro */}
          <div className="row">
            <div className="col-12">
              <div style={{ maxWidth: 900, margin: '0 auto 20px', textAlign: 'center' }}>
                <h3>Forms & Applications</h3>
                <p>
                  Start, download, or submit forms for common State of GTS services. Choose a section below to open the form page—where you can either complete an online form or download the PDF.
                </p>
              </div>
            </div>
          </div>

          <div className="row row-gutter-30">
            <div className="col-12 col-xl-10" style={{ margin: '0 auto' }}>

              {/* PERMITS */}
              <div style={sectionWrap}>
                <div style={sectionHead}>
                  <i className="fa-solid fa-file-signature" />
                  <h4 style={{ margin: 0 }}>Housing and Community Development</h4>
                </div>
                <div style={divider} />
                <ul style={list}>

                  {/* Commercial Building Permit */}
                  <li style={row}>
                    <div>
                      <h5 style={title}>Commercial Building Permit</h5>
                      <p style={desc}>
                        New commercial construction, additions, interior build-outs, and major renovations.
                      </p>
                    </div>
                    <Link
                      className="btn btn-secondary"
                      style={btnStyle}
                      to="/forms/commercial-building"
                      aria-label="Commercial Building Permit - apply or download"
                    >
                      Apply / Download
                    </Link>
                  </li>

                  {/* Combination 1–2 Family Permit */}
                  <li style={row}>
                    <div>
                      <h5 style={title}>Combination 1–2 Family Permit</h5>
                      <p style={desc}>
                        One- and two-family dwellings (combined building/trades): new builds, additions, and major alterations.
                      </p>
                    </div>
                    <Link
                      className="btn btn-secondary"
                      style={btnStyle}
                      to="/forms/one-two-family"
                      aria-label="Combination 1–2 Family Permit - apply or download"
                    >
                      Apply / Download
                    </Link>
                  </li>

                  {/* Fee schedule as a reference item */}
                  {/* <li style={row}>
                    <div>
                      <h5 style={title}>Zoning & Building Permit Fee Schedule</h5>
                      <p style={desc}>
                        Current fees for plan reviews, inspections, and permit issuance.
                      </p>
                    </div>
                    <Link
                      className="btn btn-secondary"
                      style={btnStyle}
                      to="/forms/fees"
                      aria-label="Zoning and Building Fee Schedule - view or download"
                    >
                      View / Download
                    </Link>
                  </li> */}

                </ul>
              </div>

              {/* HIGHER EDUCATION / GTSU */}
              <div style={sectionWrap}>
                <div style={sectionHead}>
                  <i className="fa-solid fa-graduation-cap" />
                  <h4 style={{ margin: 0 }}>GTS State University</h4>
                </div>
                <div style={divider} />
                <ul style={list}>
                  <li style={row}>
                    <div>
                      <h5 style={title}>Undergraduate Admission Application</h5>
                      <p style={desc}>
                        Apply to GTS State University with program preferences and academic history.
                      </p>
                    </div>
                    <Link
                      className="btn btn-secondary"
                      style={btnStyle}
                      to="/forms/undergrad"
                      aria-label="Undergraduate Admission Application - apply or download"
                    >
                      Apply
                    </Link>
                  </li>

                  <li style={row}>
                    <div>
                      <h5 style={title}>Graduate Admission Application</h5>
                      <p style={desc}>
                        Master’s/doctoral admission with program-specific materials and deadlines.
                      </p>
                    </div>
                    <Link
                      className="btn btn-secondary"
                      style={btnStyle}
                      to="/forms/grad"
                      aria-label="Graduate Admission Application - apply or download"
                    >
                      Apply
                    </Link>
                  </li>

                  {/* <li style={row}>
                    <div>
                      <h5 style={title}>Transcript Policy & Request</h5>
                      <p style={desc}>
                        Official/unofficial transcript guidance and secure submission options.
                      </p>
                    </div>
                    <Link
                      className="btn btn-secondary"
                      style={btnStyle}
                      to="/forms/transcript"
                      aria-label="Transcript policy and request - view or download"
                    >
                      View / Download
                    </Link>
                  </li> */}
                </ul>
              </div>

              {/* HEALTHCARE & FAMILY ASSISTANCE */}
              <div style={sectionWrap}>
                <div style={sectionHead}>
                  <i className="fa-solid fa-heart-pulse" />
                  <h4 style={{ margin: 0 }}>Family Support and Welfare Assistance</h4>
                </div>
                <div style={divider} />
                <ul style={list}>
                  <li style={row}>
                    <div>
                      <h5 style={title}>SNAP (Food Assistance)</h5>
                      <p style={desc}>
                        Apply for nutrition benefits; check eligibility and verification requirements.
                      </p>
                    </div>
                    <Link
                      className="btn btn-secondary"
                      style={btnStyle}
                      to="/forms/snap"
                      aria-label="SNAP - apply or download"
                    >
                      Apply / Download
                    </Link>
                  </li>

                  <li style={row}>
                    <div>
                      <h5 style={title}>Medicaid & CHIP (Health Coverage)</h5>
                      <p style={desc}>
                        Health insurance for eligible children, pregnant individuals, seniors, and people with disabilities.
                      </p>
                    </div>
                    <Link
                      className="btn btn-secondary"
                      style={btnStyle}
                      to="/forms/medicaid-chip"
                      aria-label="Medicaid and CHIP - apply or download"
                    >
                      Apply / Download
                    </Link>
                  </li>

                  {/* <li style={row}>
                    <div>
                      <h5 style={title}>WIC (Women, Infants, & Children)</h5>
                      <p style={desc}>
                        Nutrition program for pregnant/postpartum individuals and children under five.
                      </p>
                    </div>
                    <Link
                      className="btn btn-secondary"
                      style={btnStyle}
                      to="/forms/wic"
                      aria-label="WIC - apply or download"
                    >
                      Apply / Download
                    </Link>
                  </li>

                  <li style={row}>
                    <div>
                      <h5 style={title}>Families First (TANF)</h5>
                      <p style={desc}>
                        Temporary cash assistance with employment and supportive services for eligible households.
                      </p>
                    </div>
                    <Link
                      className="btn btn-secondary"
                      style={btnStyle}
                      to="/forms/tanf"
                      aria-label="TANF - apply or download"
                    >
                      Apply / Download
                    </Link>
                  </li> */}
                </ul>
              </div>

              {/* DMV */}
              <div style={sectionWrap}>
                <div style={sectionHead}>
                  <i className="fa-solid fa-id-card" />
                  <h4 style={{ margin: 0 }}>Motor Vehicles</h4>
                </div>
                <div style={divider} />
                <ul style={list}>
                  <li style={row}>
                    <div>
                      <h5 style={title}>License/ID Update</h5>
                      <p style={desc}>
                        Change of address/name, Real ID checklist, and required documents.
                      </p>
                    </div>
                    <Link
                      className="btn btn-secondary"
                      style={btnStyle}
                      to="/forms/license-id-update"
                      aria-label="License or ID Update - apply"
                    >
                      Apply
                    </Link>
                  </li>
                  <li style={row}>
                    <div>
                      <h5 style={title}>Title & Registration</h5>
                      <p style={desc}>
                        Title transfer, new registration, and renewals with emissions/insurance requirements.
                      </p>
                    </div>
                    <Link
                      className="btn btn-secondary"
                      style={btnStyle}
                      to="/forms/title-registration"
                      aria-label="Title and Registration - apply"
                    >
                      Apply
                    </Link>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FormsIndex;
